<template>
  <div>
    <div class="mb-4">
      <p class="font-bold text-lg">Topic Name</p>
      <el-input placeholder="Enter Topic Name" v-model="topicName"></el-input>
    </div>
    <div class="mb-4">
      <p class="font-bold text-lg">Topic Description</p>
      <el-input
        type="textarea"
        v-model="topicDesc"
        placeholder="Enter Topic Description"
      />
    </div>
    <div class="mb-4">
      <p class="font-bold text-lg">Link</p>
      <el-input placeholder="Enter Topic Name" v-model="link"></el-input>
    </div>
    <div class="mb-4">
      <p class="font-bold text-lg mb-2">Upload File</p>

      <div
        v-if="videopriew != null"
        class="w-36 h-36 relative img-holder mx-auto my-4"
      >
        <video
          controls
          class="w-full h-full"
          ref="myVideo"
          @loadedmetadata="videoDuration"
        >
          <source :src="videopriew" class="w-full h-full" />
        </video>
        <div class="absolute top-0 right-0">
          <feather-icon
            icon="XCircleIcon"
            svgClasses="w-5 h-5"
            class="cursor-pointer"
            @click="videopriew = null"
          />
        </div>
      </div>

      <div class="grid grid-cols-2 gap-4 bg1 rounded">
        <div class="flex flex-col justify-center items-center docs relative">
          <feather-icon
            icon="VideoIcon"
            class="mr-1"
            svgClasses="w-8 h-8"
          ></feather-icon>
          <p class="mt-4">Video</p>
          <div class="absolute top-0 left-0 docs">
            <input
              type="file"
              accept="video/*"
              class="opacityd docs w-full"
              @change="uploadvideo"
            />
          </div>
        </div>
        <div class="flex flex-col justify-center items-center docs relative">
          <!-- <img src="../../../../../../assets/images/plus.png" alt=""> -->
          <feather-icon
            icon="FileTextIcon"
            class="mr-1"
            svgClasses="w-8 h-8"
          ></feather-icon>
          <p class="mt-4">Document</p>
          <div class="absolute top-0 left-0 docs">
            <input
              type="file"
              accept="application/*"
              class="opacityd docs w-full"
              @change="uploaddocs"
            />
          </div>
        </div>
        <!-- <div class="flex flex-col justify-center items-center docs relative">
          <img src="../../../../../../assets/images/plus.png" alt="">
          <feather-icon
            icon="Link2Icon"
            class="mr-1"
            svgClasses="w-8 h-8"
          ></feather-icon>
          <p class="mt-4">Link</p>
          <div class="absolute top-0 left-0 docs">
            <input
              type="file"
              class="opacityd docs w-full"
              @change="uploadlink"
            />
          </div>
        </div> -->
      </div>
    </div>
    <div class="flex justify-center items-center mt-6">
      <vs-button color="primary" class="button2" type="filled" @click="addTopic"
        >Add Topic</vs-button
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      topicName: "",
      topicDesc: "",
      addvideo: "",
      videopriew: null,
      adddocs: "",
      docspriew: null,
      link: "",
    };
  },
  props: {
    objid: Object,
  },
  methods: {
    uploadlink() {},
    // uploaddocs() {},
    uploadvideo(e) {
      this.videopriew = null;
      console.log(e.target.files);
      this.videopriew = URL.createObjectURL(e.target.files[0]);
      console.log(this.videopriew, "videopriew");
      this.addvideo = e.target.files[0];
      // this.videoDuration();
    },
    videoDuration() {
      const video = this.$refs.myVideo;
      // video.addEventListener("loadedmetadata", () => {
      const durationInSecond = video.duration;
      let formatedDuration = this.formateDuration(durationInSecond);
      console.log(formatedDuration, "duration of a video");
      // });
    },
    formateDuration(data) {
      const hour = Math.floor(data / 3600);
      const minutes = Math.floor((data % 3600) / 60);
      const second = Math.floor(data % 60);

      return (
        (hour < 10 ? "0" : "") +
        hour +
        ":" +
        (minutes < 10 ? "0" : "") +
        minutes +
        ":" +
        (second < 10 ? "0" : "") +
        second
      );
    },
    uploaddocs(e) {
      this.docspriew = URL.createObjectURL(e.target.files[0]);
      this.adddocs = e.target.files[0];
    },
    async addTopic() {
      const payload = new FormData();
      payload.append("name", this.topicName);
      payload.append("description", this.topicDesc);
      payload.append("link", this.link);
      if (this.adddocs !== "") {
        payload.append("docType", "pdf");
        payload.append("docPath", this.adddocs);
      }
      if (this.addvideo !== "") {
        payload.append("docType", "video");
        payload.append("docPath", this.addvideo);
      }
      payload.append("chapter", this.objid.chapter);
      payload.append("course", this.objid.course);

      try {
        let data = await this.$store.dispatch(
          "elearningtopic/CreateTopic",
          payload
        );
        this.topicDesc = "";
        this.topicName = "";
        this.link = "";
        this.adddocs = "";
        this.addvideo = "";
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style>
.bg1 {
  background-color: #e5e4e2;
}

.customeicon {
  width: 50px;
  height: 50px;
}

.docs {
  height: 140px;
}
</style>
